import {
  embedHostCommandTypes,
  embedProtocolVersion,
  type EmbedHostMessage,
  type EmbedPlayerEventType,
  type EmbedPlayerPayloadMap,
} from '@retro-arcade/embed';

export interface PlayerEmbedActions {
  loadGame(game: string): Promise<boolean>;
  pause(): Promise<boolean>;
  resume(): Promise<boolean>;
  restart(): Promise<boolean>;
  setVolume(volume: number): Promise<boolean>;
  requestFullscreen(): Promise<boolean>;
}

export type PlayerEmbedEmitter = <TType extends EmbedPlayerEventType>(
  type: TType,
  payload: EmbedPlayerPayloadMap[TType],
) => void;

export async function handlePlayerEmbedCommand(
  message: EmbedHostMessage,
  actions: PlayerEmbedActions,
  emit: PlayerEmbedEmitter,
): Promise<void> {
  if (message.type === 'HOST_HELLO') {
    emit('PLAYER_READY', {
      protocolVersion: embedProtocolVersion,
      supportedCommands: embedHostCommandTypes,
    });
    return;
  }

  let ok = false;
  try {
    switch (message.type) {
      case 'LOAD_GAME':
        ok = await actions.loadGame(message.payload.game);
        break;
      case 'PAUSE':
        ok = await actions.pause();
        break;
      case 'RESUME':
        ok = await actions.resume();
        break;
      case 'RESTART':
        ok = await actions.restart();
        break;
      case 'SET_VOLUME':
        ok = await actions.setVolume(message.payload.volume);
        break;
      case 'REQUEST_FULLSCREEN':
        ok = await actions.requestFullscreen();
        break;
    }
  } catch {
    emit('PLAYER_ERROR', {
      code: 'EMBED_COMMAND_FAILED',
      message: 'The Player could not complete the requested embed command.',
      requestId: message.messageId,
    });
  }

  emit('COMMAND_RESULT', {
    requestId: message.messageId,
    command: message.type,
    ok,
    ...(ok ? {} : { code: 'COMMAND_REJECTED' }),
  });
}
